//
//

// deferred image load...
window.LoadDeferredImages = function() {

	var items = document.getElementsByClassName('deferredload');

	if (items.length) {
		for (var i = 0; i < items.length; i++) {

			var img = items[i];
			var index = i;

			if (img.getAttribute('data-src')) {
				var dataSrc = img.getAttribute('data-src');
				if (dataSrc !== '') {
					img.setAttribute('src', dataSrc);
					img.classList.add('deferredloaded');
					img.classList.remove('deferredload');
				}
			}
		}
	}
}

if (document.readyState !== 'loading') {
	window.LoadDeferredImages();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.LoadDeferredImages();
	});
}